/*
 * Lista VIP · Black November — pop-up de captação na loja.
 *
 * Abre um <dialog> com o mesmo formulário da landing page (lista-vip.js faz o envio ao Klaviyo).
 * Configuração nos data-atributos de <vip-popup>:
 *   data-delay       segundos na página antes de abrir sozinho (padrão 5)
 *   data-days        dias sem reaparecer para quem fechou (padrão 3)
 *   data-closes-at   fim das inscrições: depois disso o pop-up não existe
 *   data-suppress    "true" na página de produto e no carrinho (decidido pelo tema)
 *   data-pause-quiz  "true": enquanto a lista estiver aberta, o quiz de 10% não abre sozinho
 *   data-preview     "true": abre na hora, sem memória (só para a prévia)
 * Qualquer link para #lista-vip abre o pop-up.
 *
 * Sem dependências. Vai igual para a Shopify.
 */
(function () {
  'use strict';
  if (window.customElements && customElements.get('vip-popup')) return;

  const STORAGE = 'fn-lista-vip-bn26';

  function read() {
    try { return JSON.parse(localStorage.getItem(STORAGE)) || {}; } catch { return {}; }
  }
  function write(patch) {
    try {
      const data = read();
      for (const k in patch) data[k] = patch[k];
      localStorage.setItem(STORAGE, JSON.stringify(data));
    } catch { /* sem armazenamento: o pop-up pode reaparecer */ }
  }
  function isThemeEditor() {
    return Boolean(window.Shopify && window.Shopify.designMode);
  }
  function track(name) {
    try {
      if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
        const p = window.Shopify.analytics.publish(name, { lista: 'black-november-2026' });
        if (p && typeof p.catch === 'function') p.catch(function () {});
      }
      if (window.dataLayer && typeof window.dataLayer.push === 'function') window.dataLayer.push({ event: name });
    } catch {}
  }

  class VipPopup extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('dialog');
      if (!this.dialog || typeof this.dialog.showModal !== 'function') return;
      this.formScreen = this.querySelector('[data-vip-pop-screen="form"]');
      this.doneScreen = this.querySelector('[data-vip-pop-screen="done"]');
      this.abort = new AbortController();
      const opts = { signal: this.abort.signal };
      const self = this;

      const listOpen = this.isListOpen();
      this.active = listOpen || isThemeEditor();
      if (!this.active) return;

      if (listOpen && this.dataset.pauseQuiz === 'true') this.pauseQuiz();

      this.querySelectorAll('[data-vip-pop-close]').forEach(function (btn) {
        btn.addEventListener('click', function () { self.close(); }, opts);
      });
      // Clique fora do cartão (no fundo escurecido) fecha
      this.dialog.addEventListener('click', function (e) { if (e.target === self.dialog) self.close(); }, opts);
      this.dialog.addEventListener('cancel', function () { self.markDismissed(); }, opts);
      this.addEventListener('vip:inscrita', function () { self.showDone(); }, opts);

      document.addEventListener('click', function (e) {
        const link = e.target.closest && e.target.closest('a[href$="#lista-vip"]');
        if (!link) return;
        e.preventDefault();
        self.open();
      }, opts);
      // Editor de tema: abrir e fechar ao selecionar a seção
      document.addEventListener('shopify:section:select', function (e) {
        if (e.target && e.target.contains && e.target.contains(self)) self.open();
      }, opts);
      document.addEventListener('shopify:section:deselect', function (e) {
        if (e.target && e.target.contains && e.target.contains(self)) self.close(true);
      }, opts);

      if (this.dataset.preview === 'true' || location.hash === '#lista-vip') {
        this.open();
        return;
      }
      if (this.shouldAutoShow()) {
        this.timer = setTimeout(function () {
          self.timer = null;
          if (self.isConnected && !self.everOpened && self.shouldAutoShow()) self.open();
        }, (parseFloat(this.dataset.delay) || 5) * 1000);
      }
    }

    disconnectedCallback() {
      if (this.abort) this.abort.abort();
      if (this.timer) clearTimeout(this.timer);
    }

    isListOpen() {
      const now = Date.now();
      const opensAt = Date.parse(this.dataset.opensAt || '');
      const closesAt = Date.parse(this.dataset.closesAt || '');
      const started = isNaN(opensAt) || now >= opensAt;
      const ended = !isNaN(closesAt) && now >= closesAt;
      return started && !ended;
    }

    shouldAutoShow() {
      if (this.dataset.suppress === 'true') return false;
      if (isThemeEditor()) return false;
      const s = read();
      if (s.inscrita) return false;
      if (!s.fechou) return true;
      const days = parseFloat(this.dataset.days) || 3;
      return Date.now() - s.fechou > days * 86400000;
    }

    // O quiz revalida data-auto na hora de abrir: desligar aqui basta, sem mexer no código dele
    pauseQuiz() {
      const mark = function () {
        document.querySelectorAll('quiz-popup').forEach(function (q) { q.setAttribute('data-auto', 'false'); });
      };
      mark();
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mark, { once: true });
    }

    open() {
      if (!this.active) return;
      this.everOpened = true;
      // Outra janela aberta (quiz, carrinho) ganha a vez
      const other = document.querySelector('dialog[open]');
      if (other && other !== this.dialog) return;
      if (!this.dialog.open) {
        this.dialog.showModal();
        track('lista_vip_popup_aberto');
      }
    }

    close(silent) {
      if (!this.dialog.open) return;
      this.dialog.close();
      if (!silent && !this.done) this.markDismissed();
    }

    markDismissed() {
      if (this.done) return;
      write({ fechou: Date.now() });
    }

    showDone() {
      this.done = true;
      write({ inscrita: true });
      track('lista_vip_popup_inscricao');
      this.formScreen.hidden = true;
      this.doneScreen.hidden = false;
      const title = this.querySelector('[data-vip-pop-done-title]');
      if (title) title.focus();
    }
  }

  customElements.define('vip-popup', VipPopup);
})();
